import { configureStore } from '@reduxjs/toolkit';
import { lastWrittenAtSlice } from './lastWrittenAtSlice';
export const store = configureStore({
    reducer: {
        lastWrittenAt: lastWrittenAtSlice.reducer,
    },
});
